<div class="flex flex-col gap-5">
    <!-- Search -->
    <mat-form-field class="w-full sm:w-[250px] translate-y-[10px] transform-gpu" *ngIf="!settings?.hideSearch">
        <mat-icon matIconPrefix svgIcon="search"></mat-icon>
        <input matInput i18n-placeholder placeholder="Zoeken" [formControl]="searchControl">
        <!-- Clear button -->
        <button mat-icon-button class="selection-clear" (click)="$event.stopPropagation(); searchControl.reset()"
            [disableRipple]="true" *ngIf="searchControl.value" aria-label="Veld leegmaken">
            <mat-icon svgIcon="x"></mat-icon>
        </button>
    </mat-form-field>

    <!-- Table -->
    <div class="overflow-auto">
        <table mat-table [dataSource]="filteredItems" matSort #table multiTemplateDataRows
            [ngClass]="{'invisible': !initialLoadCompleted}">

            <!-- Checkbox Column -->
            <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="toggleAllRows($event)" [checked]="isMainChecked()"
                        [indeterminate]="isMainIntermediate()" color="primary">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row.id)"
                        [checked]="selection.isSelected(row.id)" color="primary">
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Columns -->
            <ng-content></ng-content>

            <!-- Delete column -->
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let item" class="text-app-global-warning">
                    <div class="flex items-end justify-end">
                        <button mat-icon-button (click)="rowDeleted.next(item)" aria-label="verwijderen">
                            <mat-icon svgIcon="trash-2"></mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <!-- Expand column -->
            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let item" class="text-right">
                    <button mat-icon-button aria-label="uitklappen">
                        <mat-icon svgIcon="chevron-down" class="expand-chevron"
                            [class.rotated]="expandedItem === item"></mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let item" [attr.colspan]="displayedColumns.length">
                    <div class="collapsed-content" [class.expanded-content]="item === expandedItem"
                        [@detailExpand]="item == expandedItem ? 'expanded' : 'collapsed'">
                        <div class="pt-2 pb-4">
                            <ng-container
                                *ngTemplateOutlet="expandedTemplate; context: { $implicit: item }"></ng-container>
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- Table rows -->
            <ng-container *ngIf="!settings?.hideHeader">
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayedColumns; let last = last"
                [class.routing-enabled]="settings?.routerLinkFunction(row)"
                [class.no-border]="settings?.enableExpansion" [class.bottom-border]="!settings?.hidePaginator && last"
                (click)="routeOrExpand(row)">
            </tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    <p class="text-app-global-text-secondary">Geen resultaten gevonden</p>
                </td>
            </tr>

            <!-- Row shown when expanded -->
            <ng-container *ngIf="settings?.enableExpansion">
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="h-0 expanded-row"></tr>
            </ng-container>

        </table>
    </div>

    <!-- Paginator -->
    <mat-paginator [pageSizeOptions]="[5, 10, 25]" pageSize="10" [class.hide-paginator]="settings?.hidePaginator"
        [class.hide-label]="!breakpoint.sm.value" [hidePageSize]="settings?.hidePageSize"
        [ngClass]="{'paginator-hidden': settings?.hidePageSize}"></mat-paginator>
</div>